import { Pipe, PipeTransform } from '@angular/core';
import { SurveyElementType } from '../models/submissions/submission-list-item.model';

const severityScaleChoices = {
  0: "answers.nothing",
  1: "answers.little",
  2: "answers.moderately",
  3: "answers.a_bit",
  4: "answers.very",
};

const foodEatenChoices = {
  0: "answers.percent_0",
  1: "answers.percent_1",
  2: "answers.percent_2",
  3: "answers.percent_3",
  4: "answers.percent_4",
};

const foodIntakeQuestions = [
  "Hast Du in den letzten 5 Tagen deutlich weniger gegessen als sonst? (Weniger als ein Viertel der Menge, die Du normalerweise zu Dir nimmst)"
];

@Pipe({
  name: 'answerDisplay',
})
export class AnswerDisplayPipe implements PipeTransform {
  transform(value: unknown, question: string, type: SurveyElementType, options: { label: { de: string, en: string }, value: number }[]): string {
    if (type === SurveyElementType.SingleSelect) {
      const answerValue = value as number;
      if (foodIntakeQuestions.includes(question)) {
        return foodEatenChoices[answerValue] || "answers.unknown";
      }
      return severityScaleChoices[answerValue] || "answers.unknown";
    } else if (type === SurveyElementType.MultiSelect) {
      const selectedValues = value as number[];
      return options
        .map(option => `${option.label.de}: ${selectedValues.includes(option.value) ? 'Ja' : 'Nein'}`)
        .join(', ');
    } else {
      return value as string;
    }
  }
}
